import { isValidDate, isValidBirthDate } from '@usas/ui-web/utils/validation';
import Constants from '@usas/ui-web/utils/Constants';

export const localValidate = (formState) => {

  let errors = {};

  if (formState.sponsorId < 0) {
    errors.sponsorId = 'Sponsor is required';
  }

  //effective date
  if (formState.effectiveDate === Constants.BLANK_DATE_STRING) {
    errors.effectiveDate = 'Effective Date is required';
  } else if (!isValidDate(formState.effectiveDate)) {
    errors.effectiveDate = 'Effective Date must be a valid date';
  } else if (!isValidBirthDate(formState.effectiveDate)) {
    errors.effectiveDate = 'Effective Date cannot be in the future';
  }

  //expire date
  if (formState.expirationDate === Constants.BLANK_DATE_STRING) {
    errors.expirationDate = 'Expiration Date is required';
  } else if (!isValidDate(formState.expirationDate)) {
    errors.expirationDate = 'Expiration Date must be a valid date';
  } 

  const startDate = new Date(formState.effectiveDate);
  const endDate = new Date(formState.expirationDate);

  //Effective Date
  if (formState.effectiveDate !== Constants.BLANK_DATE_STRING) {
    if (endDate < startDate && formState.effectiveDate !== formState.expirationDate) {
      errors.effectiveDate = 'Effective Date must be before the Expiration Date';
    } 
  }

  //Expiration Date
  if (formState.expirationDate !== Constants.BLANK_DATE_STRING) {
    if (endDate < startDate && formState.effectiveDate !== formState.expirationDate) {
      errors.expirationDate = 'Expiration Date must be after the Effective Date';
    }
  }
  
  return errors;
};

const NationalTeamSponsorDetailValidation = async (formState) => {
  let errors = localValidate(formState);

  return errors ? errors : {};
}

export default NationalTeamSponsorDetailValidation;